import { MessageBox } from 'element-ui'

let hasOpened = false
let closeHandle = null
const msgQueen = [] // FIFO 队列

export default {
  install(Vue) {
    Vue.prototype.$autoCloseMsg = function(time = 3000, options = {}, cover = true) {
      const opts = {
        title: '提示',
        type: 'info',
        showClose: false,
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        ...options
      }

      // 如果已经打开又调用
      if (closeHandle && hasOpened) {
        if (cover) {
          // 覆盖上一个
          MessageBox.close()
        } else {
          // 加入队列等待上一个隐藏再显示
          msgQueen.push({
            time,
            options,
            cover
          })
          return
        }
      }

      closeHandle = setTimeout(_ => {
        MessageBox.close()
        closeHandle = null
        hasOpened = false
        if (msgQueen.length) {
          // 队列存在未打开消息, 取出第一个
          const { time, options, cover } = msgQueen.shift()
          this.$autoCloseMsg(time, options, cover)
        }
      }, time)
      hasOpened = true

      // 返回 promise
      return MessageBox(opts)
    }
  },

}
